import { travel } from 'api';
import { CancelToken } from 'axios';

export interface GetTravelsByUserRequest {
  UserId: string;
  cancelToken: CancelToken;
}

export interface GetTravelDetailByIdRequest {
  TravelId: string;
  cancelToken: CancelToken;
}

export function getTravelsByUser({ UserId, cancelToken }: GetTravelsByUserRequest) {
  return travel.get('Travels/GetTravelsByUser', { cancelToken, params: { UserId } }).then((r) => r.data);
}

export function getTravelDetailById({ TravelId, cancelToken }: GetTravelDetailByIdRequest) {
  return travel.get('Travels/GetTravelDetailById', { cancelToken, params: { TravelId } }).then((r) => r.data);
}
